import { actionCreatorFactory } from 'typescript-fsa'
import { House } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerHouses = actionCreator<House[]>('registerHouses')
